// Liste sayfaları için açılır filtre çubuğu — chevron toggle + dinamik alanlar.
// Tüm filtreler "anında uygula" (controlled) — parent values/onChange ile bağlanır.
//
// Kullanım:
//   <FilterBar
//     show={showBar} onToggle={() => setShowBar(s => !s)}
//     values={filters} onChange={setFilters}
//     fields={[
//       { key: 'date_from', type: 'date',   label: 'İlk Tarih' },
//       { key: 'date_to',   type: 'date',   label: 'Son Tarih' },
//       { key: 'account_id',type: 'select', label: 'Cari', options: [{value:'',label:'Tüm Cariler'}, ...] , flex: '1 1 240px' },
//       { key: 'status',    type: 'select', label: 'Durum', options: [{value:'',label:'Tümü'}, {value:'approved',label:'Onaylı'}, ...] },
//       { key: 'min_amount',type: 'number', label: 'Min Tutar', step: 0.01 },
//       { key: 'q',         type: 'text',   label: 'Anahtar Kelime', placeholder: 'Ara...' },
//     ]}
//   />
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';

export default function FilterBar({ show, onToggle, fields = [], values = {}, onChange }) {
  const { t } = useTranslation();
  const labelStyle = { fontSize: '0.72rem', color: 'var(--text-tertiary)', display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.4 };
  const inputStyle = { padding: '6px 10px', borderRadius: 8, border: '1px solid var(--border-input)', background: 'var(--bg-input)', color: 'var(--text-primary)', fontSize: '0.85rem' };

  const update = (key, val) => onChange && onChange({ ...values, [key]: val });
  const clearAll = () => {
    if (!onChange) return;
    const empty = {};
    fields.forEach(f => { empty[f.key] = f.type === 'select' && f.options?.[0] ? f.options[0].value : ''; });
    onChange(empty);
  };

  // Aktif filtre sayısı — boş string / null / undefined / "all" sayılmaz
  const isActive = (f) => {
    const v = values[f.key];
    if (v == null || v === '' || v === false) return false;
    if (f.type === 'select' && f.options?.[0]?.value === v) return false;  // ilk option (Tümü) varsayılan
    return true;
  };
  const activeCount = fields.filter(isActive).length;

  const renderField = (f) => {
    const v = values[f.key] ?? '';
    if (f.type === 'select') {
      return (
        <select value={v} onChange={e => update(f.key, e.target.value)} style={{ ...inputStyle, width: '100%' }}>
          {(f.options || []).map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      );
    }
    if (f.type === 'date') {
      return <input type="date" value={v} onChange={e => update(f.key, e.target.value)} style={inputStyle} />;
    }
    if (f.type === 'number') {
      return <input type="number" value={v} step={f.step || 1} min={f.min} max={f.max} placeholder={f.placeholder || ''}
                    onChange={e => update(f.key, e.target.value)} style={inputStyle} />;
    }
    // text, default
    return <input type="text" value={v} placeholder={f.placeholder || ''} onChange={e => update(f.key, e.target.value)} style={inputStyle} />;
  };

  return (
    <>
      {/* Açılır içerik */}
      <div style={{
        maxHeight: show ? 200 : 0,
        overflow: 'hidden',
        transition: 'max-height 0.25s ease-out',
        background: 'var(--bg-card)',
        borderBottom: show ? '1px solid var(--border-secondary)' : 'none',
      }}>
        <div style={{ padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end' }}>
          {fields.map(f => (
            <div key={f.key} style={{ flex: f.flex || '0 0 auto', minWidth: f.minWidth || 0 }}>
              <label style={labelStyle}>{f.label}</label>
              {renderField(f)}
            </div>
          ))}
          {activeCount > 0 && (
            <Button variant="ghost" size="sm" onClick={clearAll}>✕ Temizle</Button>
          )}
        </div>
        <div style={{ padding: '0 16px 8px', fontSize: '0.72rem', color: 'var(--text-tertiary)', fontStyle: 'italic' }}>
          {t('ui.filterApplies')}
        </div>
      </div>

      {/* Aç/Kapa kolu — chevron */}
      <div onClick={onToggle}
        title={show ? t('ui.filterClose') : t('ui.filterOpen')}
        style={{
          cursor: 'pointer', textAlign: 'center', padding: '4px 8px',
          background: activeCount > 0 ? 'rgba(59,130,246,0.08)' : 'var(--bg-secondary)',
          borderBottom: '1px solid var(--border-secondary)',
          color: activeCount > 0 ? 'var(--accent-primary)' : 'var(--text-tertiary)',
          fontSize: '0.72rem', userSelect: 'none', transition: 'background 0.12s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(59,130,246,0.12)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = activeCount > 0 ? 'rgba(59,130,246,0.08)' : 'var(--bg-secondary)'; }}
      >
        {show ? '▲' : '▼'} {t('ui.filter')} {activeCount > 0 && <strong>({activeCount})</strong>}
      </div>
    </>
  );
}
